import { LagoonSDK } from './lagoonSDK';
import { getLagoonEnv } from './helpers';

const lagoonEnv = getLagoonEnv();
const ppdNamespace = 'sde-ppd';
const ppdSchema = {
  loadTables: true,
  loadForms: false,
};

export const ppdLagoon = new LagoonSDK(ppdNamespace, lagoonEnv, ppdSchema);
